import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {CreateForm} from "./CreateForm";
import {Form} from "react-bootstrap";
import {ErrorToast, SuccessToast} from "../../../shared/toasters/toasters";
import {useTranslation} from "react-i18next";
import {AdminBannerService} from "../service";
import {IBanner} from "../interface";

export const UpdateBanner = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [zones, setZones] = useState<any[]>();
  const [state, setState] = useState<IBanner | null>(null);
  const [triggerUpdate, setTriggerUpdate] = useState(false);
  const [image, setImage] = useState<File | null>(null);


    const submitHandler = () => {
    if (state?.id) {
        const formData = new FormData();
        formData.append('body', JSON.stringify({...state, zone: state?.zone?.id ? state?.zone?.id : state?.zone,}))
        image && formData.append("image", image);
      AdminBannerService.update(formData, state?.id)
        .then(() => {
          SuccessToast(t(`banner.successfully_updated`));
          navigate("/admin/banner");
          setTriggerUpdate(!triggerUpdate);
          setState(null);
        })
        .catch(ErrorToast);
    }
  };
  useEffect(() => {
    AdminBannerService.getAllZone({
      page: 0,
      perPage: 0,
    })
      .then((response) => {
        const { data } = response;
        setZones(data?.items);
        window.scrollTo(0, 0);
      })
      .catch(ErrorToast);
  }, []);
  return (
    <div className="col-12">
      <Form
        onSubmit={(e) => {
            e.preventDefault();
            submitHandler();
        }}
      >
        <CreateForm state={state} setState={setState} setImage={setImage} zones={zones} />
      </Form>
    </div>
  );
};
